import { Component, OnInit, Input, ViewChild, AfterViewInit, ChangeDetectorRef, HostListener, ElementRef, ViewContainerRef, Renderer2 } from '@angular/core';
import { NavParams, Events, ViewController, ToastController } from 'ionic-angular';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { DriveServiceProvider } from '../../../providers/drive-service/drive-service';
import { ConfigApiServiceProvider } from '../../../providers/config-api-service/config-api-service';
import { ConfigureServiceProvider } from '../../../providers/configure-service/configure-service';
import { StoreWrapProvider } from '../../../providers/store-wrap/store-wrap';
import { ContactManagerProvider } from '../../../providers/contact-manager/contact-manager';
import { MailSchedulerProvider } from '../../../providers/mail-scheduler/mail-scheduler';
import { from } from 'rxjs';

declare var jQuery;
@Component({
  selector: 'mail-campaign',
  templateUrl: 'mail-campaign.html'
})
export class

  MailCampaignComponent implements OnInit, AfterViewInit {
  addLink: boolean = true;
  mailFolderId: any = {};
  objCurrentFolderProperties: any;
  showCc: boolean = false;
  showBcc: boolean = false;
  height: any = 35;
  list: any = [];
  folder: any;
  show: boolean = false;
  showList: boolean = false;
  bccSelectedFolder: any = [];
  ccSelectedFolder: any = [];
  toSelectedFolder: any = [];
  addedFile: any;
  fieldData: any;
  contextValueTo: any = [];
  contextValueCc: any = [];
  contextValueBcc: any = [];
  mailIdTo: any = [];
  mailIdBcc: any = [];
  mailIdCc: any = [];
  mailData: any;
  tempData: any;
  // fieldValues:any;
  currentSelectedTo: any;
  currentSelectedCc: any;
  currentSelectedBcc: any;
  fieldValues: any = { "From": "", "To": "", "Cc": "", "Bcc": "", "Subject": "", "Body": "", "CampaignName": "", "CampaignID": "" };
  toMail: any = [];
  bccMail: any = [];
  ccMail: any = [];
  arrListContactFolder: any = [];
  arrListContactBccFolder: any = [];
  arrListContactCCFolder: any = [];
  arrListContactToFolder: any = [];
  formMailOpt: any = [];
  objData: any = {};
  @Input() params: any;
  @Input() form: any;
  _formFields: any = [];
  arrTemplateFields: any = [];
  selectedTemplate: any = [];
  target: any;
  @Input() set formFields(f: any) {
    this._formFields = f;
  }

  _formLayout: any[] = [];
  @Input() set formLayout(v: any) {
    this._formLayout = v;
  };
  contextMenuAddContainer: any = '';
  public arrTemplates = []
  link: any = "#";
  TagName: any = '';
  Body: any = '';
  isItemAvailable: any = false; // Declare the variable (in this case isItemAvailable) 
  istoItemAvailable = false;
  isbccItemAvailable = false;
  isccItemAvailable = false;
  itemsto = [];
  itemsbcc = [];
  itemscc = [];
  index: any = 0;
  clipboardData: any;
  shareDataType: boolean = false;
  accessType: any = "public";
  mailTemplate: any = 'Default';
  contextMenuActions = [
    {
      arrayList: this.contactManager.getCurrentFolderTemplate(this.navParams.get('objCurrentFolderProperties')),
      click: (event, item) => this.getTemplateFields(event, item),
      mouseover: (event, item) => this.getTemplateFields(event, item),
      enabled: (item) => true,
      visible: (item) => true,
      subActions: [{
        arrayList: this.arrTemplateFields,
        click: (event, item) => alert('submenu'),
        enabled: (item) => true,
        visible: (item) => true,
      }],
    }

  ];
  acessType: any = [{
    "key": "private",
    "value": "private"
  },
  {
    "key": "public",
    "value": "public"
  }]
  getTemplateFields(e, temp) {
    this.arrTemplateFields = [];
    this.arrTemplateFields = temp['formLayout'][0][0]["fields"];
    this.selectedTemplate = temp.id;
    return this.arrTemplateFields;
  }
  enteredTagEmail = []
  @ViewChild(ContextMenuComponent, { static: true }) public contextMenu: ContextMenuComponent;

  /* * * * * *
   * ck Editor
   * * * * * */
  name = 'ng2-ckeditor';
  ckeConfig: any;
  mycontent: string;
  log: string = '';
  @ViewChild('myckeditor', { read: ViewContainerRef, static: false }) ckeditor: ViewContainerRef;
  constructor(public toastController: ToastController, public configureService: ConfigureServiceProvider, private contextMenuService: ContextMenuService, public navParams: NavParams, public configApi: ConfigApiServiceProvider, public contactManager: ContactManagerProvider, public mailScheduler: MailSchedulerProvider, public cdr: ChangeDetectorRef, public event: Events, public driveService: DriveServiceProvider, private storeWrap: StoreWrapProvider, public viewCtrlScheduler: ViewController) {
  }

  ngOnInit() {
    /* * * * * *
    * ck Editor config
    * * * * * */
    this.ckeConfig = {
      allowedContent: false,
      forcePasteAsPlainText: true,
      removePlugins: 'contextmenu,liststyle,tabletools,tableselection',
      font_names: 'Arial;Times New Roman;Verdana',
      toolbarGroups: [
        { name: 'document', groups: ['mode', 'document', 'doctools'] },
        { name: 'clipboard', groups: ['clipboard', 'undo'] },
        { name: 'editing', groups: ['find', 'selection', 'editing'] },
        { name: 'forms', groups: ['forms'] },
        '/',
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
        { name: 'links', groups: ['links', 'Anchor', 'Image'] },
        { name: 'insert', groups: ['insert', 'Table', 'CreateDiv', 'PageBreak', 'Iframe'] },
        '/',
        { name: 'styles', groups: ['styles'] },
        { name: 'colors', groups: ['colors'] },
        { name: 'tools', groups: ['tools'] },
        { name: 'others', groups: ['others'] },
        { name: 'about', groups: ['about'] }
      ],
      removeButtons: 'Source,Save,NewPage,Preview,Print,spellchecker,Templates,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,Strike,Subscript,Superscript,CopyFormatting,RemoveFormat,Outdent,Indent,Blockquote,BidiLtr,BidiRtl,Language,Unlink,Flash,HorizontalRule,Smiley,SpecialChar,Maximize,ShowBlocks,About'
    };

    this.formMailOpt = this.navParams.get('formMailOpt');
    this.fieldValues = Object.assign({}, this.fieldValues, this.navParams.get('data'));
    this.mailFolderId = this.fieldValues.mailFolderId ? eval('(' + this.fieldValues.mailFolderId + ')') : {};
    this.link = this.navParams.get('link') || '';
    // if (this.fieldValues.Body == '') {
    //   this.fieldValues.Body = '<p><a href="' + this.link + '" style=cursor: pointer;>User Link</a></p></p>'
    // }
    let attachment_template: any = {};
    if (this.fieldValues.attachment_template) {
      if (typeof this.fieldValues.attachment_template != "object") {
        this.accessType = JSON.parse(this.fieldValues.attachment_template).accessType;
      } else {
        this.accessType = this.fieldValues.attachment_template.accessType
      }
      if (typeof this.fieldValues.attachment_template !== "string") {
        attachment_template = this.fieldValues.attachment_template;
      } else {
        attachment_template = eval('(' + this.fieldValues.attachment_template + ')');
        this.fieldValues.attachment_template = attachment_template;
      }
      if (attachment_template.hasOwnProperty('attachmentLink') && attachment_template.attachmentLink == true) {
        this.addLink = true;
      } else {
        this.addLink = false;
      }
      if (attachment_template.hasOwnProperty('ShareType') && attachment_template.ShareType == 'Folder') {
        this.shareDataType = true;
      } else {
        this.shareDataType = false;
      }
      if (this.fieldValues.attachment_template.enterEmail) {
        this.enteredTagEmail = this.fieldValues.attachment_template.enterEmail;
      }
    }
    this.TagName = this.navParams.get('TagName');
    this.objCurrentFolderProperties = this.navParams.get('objCurrentFolderProperties');
    if (this.fieldValues['Body']) {
      this.fieldValues.Body = this.fieldValues.Body.trimEnd()
    } else {
      this.fieldValues.Body = "<p>Please find the details of your data from the above link</p>";
    }
    delete this.fieldValues["RowNumber"];
    let toSelectedFolderValue = [], bccSelectedFolderValue = [], ccSelectedFolderValue = [];
    this.arrListContactFolder = this.contactManager.getContactFolders();
    this.toSelectedFolder = this.FolderList(this.contactManager.getSelectedFolders(this.fieldValues.mailFolderId, 'to'));
    toSelectedFolderValue = this.appendContextValueMail('To', this.toSelectedFolder, true) || [];
    if (this.enteredTagEmail.length != 0) {
      this.enteredTagEmail.forEach(Element => {
        this.toSelectedFolder.push(Element)
      })
    }
    if (toSelectedFolderValue.length > 0) {
      this.toSelectedFolder = toSelectedFolderValue;
    }
    this.contextValueTo = this.appendContextValueMail('To', this.toSelectedFolder, false) || [];
    this.bccSelectedFolder = this.FolderList(this.contactManager.getSelectedFolders(this.fieldValues.mailFolderId, 'bcc'));
    bccSelectedFolderValue = this.appendContextValueMail('Bcc', this.bccSelectedFolder, true) || [];
    if (bccSelectedFolderValue.length > 0) {
      this.bccSelectedFolder = bccSelectedFolderValue;
    }
    this.contextValueBcc = this.appendContextValueMail('Bcc', this.bccSelectedFolder, false) || [];
    this.ccSelectedFolder = this.FolderList(this.contactManager.getSelectedFolders(this.fieldValues.mailFolderId, 'cc'));
    ccSelectedFolderValue = this.appendContextValueMail('Cc', this.ccSelectedFolder, true) || [];
    if (ccSelectedFolderValue.length > 0) {
      this.ccSelectedFolder = ccSelectedFolderValue;
    }
    this.contextValueCc = this.appendContextValueMail('Cc', this.ccSelectedFolder, false) || [];
    this.toMail = this.fieldValues.To ? this.fieldValues.To.split(',').filter(item => item.search('<<') == -1) : [];
    this.ccMail = this.fieldValues.Cc ? this.fieldValues.Cc.split(',').filter(item => item.search('<<') == -1) : [];
    this.bccMail = this.fieldValues.Bcc ? this.fieldValues.Bcc.split(',').filter(item => item.search('<<') == -1) : [];
    this.showBcc = this.bccSelectedFolder.length > 0 ? true : false;
    this.showCc = this.ccSelectedFolder.length > 0 ? true : false;
  }

  appendContextValueMail(key, value, status) {
    var contextValueArr = [];
    for (var i = 0; i < this.fieldValues[key].split(',').length; i++) {
      if (this.fieldValues[key].split(',')[i].search('<<') != -1) {
        if (status == true) {
          value.push(this.fieldValues[key].split(',')[i]);
          if (i == this.fieldValues[key].split(',').length - 1) {
            return value;
          }
        } else {
          contextValueArr.push(this.fieldValues[key].split(',')[i]);
          if (i == this.fieldValues[key].split(',').length - 1) {
            return contextValueArr;
          }
        }
      }
    }
  }

  FolderList(list) {
    var folder_list = [];
    if (list.length > 0) {
      list.forEach(element => {
        if (folder_list.length > 0) {
          let index: any = folder_list.findIndex(e => e == element.name);
          if (index == -1) {
            folder_list.push(element.name);
          } else if (index >= 0) {
            folder_list.splice(index, 1);
            folder_list.push(element.name);
          }
        } else {
          folder_list.push(element.name);
        }
      });
      return folder_list;
    } else {
      return folder_list;
    }

  }

  initializeItems() {
    this.arrListContactFolder = this.contactManager.getContactFolders();
    this.arrListContactBccFolder = this.contactManager.getContactFolders();
    this.arrListContactCCFolder = this.contactManager.getContactFolders();
    this.arrListContactToFolder = this.contactManager.getContactFolders();
  }

  onShowBcc() {
    if (this.showBcc == true) {
      this.showBcc = false;
    } else {
      this.showBcc = true;
    }

  }
  onShowCc() {
    if (this.showCc == true) {
      this.showCc = false;
    } else {
      this.showCc = true;
    }

  }

  onChange(e, key) {
    var mailFolderIdArr = [];
    var mailTagValue = jQuery('#' + key + 'Mail').find('a.iti-tag-rm.activated').parent().text().trim();
    if (key == 'to' && this.contextValueTo.findIndex(item => item == mailTagValue) != -1 || key == 'cc' && this.contextValueCc.findIndex(item => item == mailTagValue) != -1 || key == 'bcc' && this.contextValueBcc.findIndex(item => item == mailTagValue) != -1) {
      if (key == 'to') {
        var mailTagIdx = this.contextValueTo.findIndex(item => item == mailTagValue);
        this.contextValueTo.splice(mailTagIdx, 1);
      } else if (key == 'cc') {
        var mailTagIdx = this.contextValueCc.findIndex(item => item == mailTagValue);
        this.contextValueCc.splice(mailTagIdx, 1);
      } else if (key == 'bcc') {
        var mailTagIdx = this.contextValueBcc.findIndex(item => item == mailTagValue);
        this.contextValueBcc.splice(mailTagIdx, 1);
      }

    } else {
      if (Object.keys(this.mailFolderId).length) {
        mailFolderIdArr = this.mailFolderId[key].split(',');
        for (var i = 0; i < mailFolderIdArr.length; i++) {
          var folderIndex = this.arrListContactFolder.findIndex(item => item.folder_id == mailFolderIdArr[i]);
          var mailFolderNameIdx = e.findIndex(item => item == this.arrListContactFolder[folderIndex]["name"]);
          if (mailFolderNameIdx == -1) {
            if (key == 'to' && mailFolderIdArr.length == this.toMail.length) {
              this.toMail.splice(i, 1);
              mailFolderIdArr.splice(i, 1)
              return;
            } else if (key == 'cc' && mailFolderIdArr.length == this.ccMail.length) {
              this.ccMail.splice(i, 1);
              mailFolderIdArr.splice(i, 1)
              return;
            } else if (key == 'bcc' && mailFolderIdArr.length == this.bccMail.length) {
              this.bccMail.splice(i, 1);
              mailFolderIdArr.splice(i, 1)
              return;
            }
            else if (this.arrListContactFolder[folderIndex].files.length > 0) {
              if (this.arrListContactFolder[folderIndex].files[0].length <= 0) {
                this.getMailList(this.arrListContactFolder[folderIndex], key, true, i);
                return;
              } else if (this.arrListContactFolder[folderIndex].files.length > 0) {
                this.getMailList(this.arrListContactFolder[folderIndex], key, true, i);
                return;
              }
            } else if (this.arrListContactFolder[folderIndex].files.length <= 0) {
              if (this.arrListContactFolder[folderIndex].files.length <= 0) {
                this.getMailList(this.arrListContactFolder[folderIndex], key, true, i);
                return;
              }
            }


          }
        }
        this.mailFolderId[key] = mailFolderIdArr.toString();
      }
    }
  }


  getItems(ev: any, key) {
    this.initializeItems();
    const val = ev.target.value;
    if (ev.keyCode != 27) {
      if (val && val.trim() != '') {
        if (key == 'to') {
          this.istoItemAvailable = true;
          this.arrListContactToFolder = this.arrListContactFolder.filter((item) => {
            return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
          })
        }
        if (key == 'bcc') {
          this.isbccItemAvailable = true;
          this.arrListContactBccFolder = this.arrListContactFolder.filter((item) => {
            return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
          })
        }
        if (key == 'cc') {
          this.isccItemAvailable = true;
          this.arrListContactCCFolder = this.arrListContactFolder.filter((item) => {
            return (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1);
          })
        }
      }
    }
    else {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = false;
    }

  }
  openContactFolders(ev, key) {
    if (key == "to") {
      this.istoItemAvailable = true;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = false;
    } else if (key == "bcc") {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = true;
      this.isccItemAvailable = false;
    } else if (key == "cc") {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = true;
    }
  }

  public onAddto(item) {
    if (this.toSelectedFolder.length == 0) {
      if (item.value != '') {
        this.toSelectedFolder.push(item.value);
        this.getMailList(item.display, 'to');
      }
    } else {
      let index: any = this.toSelectedFolder.findIndex(element => element == item.value);
      if (index == -1) {
        if (item.value != '') {
          this.toSelectedFolder.push(item.value);
          this.getMailList(item.display, 'to');
        }
      } else if (index >= 0) {
        this.toSelectedFolder.splice(index, 1);
        var mailFolderIdArray = this.mailFolderId['to'].split(',');
        mailFolderIdArray.splice(index, 1);
        this.mailFolderId['to'] = mailFolderIdArray.toString();
        if (item.value != '') {
          this.toSelectedFolder.push(item.value);
          mailFolderIdArray.push(this.arrListContactFolder[this.arrListContactFolder.findIndex(element => element.name == item.value)]['folder_id']);
          this.mailFolderId['to'] = mailFolderIdArray.toString();
        }
      }
    }
  }

  public onAddcc(item) {
    if (this.ccSelectedFolder.length == 0) {
      if (item.value != '') {
        this.ccSelectedFolder.push(item.value);
        this.getMailList(item.display, 'cc');
      }
    } else {
      let index: any = this.ccSelectedFolder.findIndex(element => element == item.value);
      if (index == -1) {
        if (item.value != '') {
          this.ccSelectedFolder.push(item.value);
          this.getMailList(item.display, 'cc');
        }
      } else if (index >= 0) {
        this.ccSelectedFolder.splice(index, 1);
        var mailFolderIdArray = this.mailFolderId['cc'].split(',');
        mailFolderIdArray.splice(index, 1);
        this.mailFolderId['cc'] = mailFolderIdArray.toString();
        if (item.value != '') {
          this.ccSelectedFolder.push(item.value);
          mailFolderIdArray.push(this.arrListContactFolder[this.arrListContactFolder.findIndex(element => element.name == item.value)]['folder_id']);
          this.mailFolderId['cc'] = mailFolderIdArray.toString();
        }
      }
    }
  }
  public onAddbcc(item) {
    if (this.bccSelectedFolder.length == 0) {
      if (item.value != '') {
        this.bccSelectedFolder.push(item.value);
        this.getMailList(item.display, 'bcc');
      }
    } else {
      let index: any = this.bccSelectedFolder.findIndex(element => element == item.value);
      if (index == -1) {
        if (item.value != '') {
          this.bccSelectedFolder.push(item.value);
          this.getMailList(item.display, 'bcc');
        }
      } else if (index >= 0) {
        this.bccSelectedFolder.splice(index, 1);
        var mailFolderIdArray = this.mailFolderId['bcc'].split(',');
        mailFolderIdArray.splice(index, 1);
        this.mailFolderId['bcc'] = mailFolderIdArray.toString();
        if (item.value != '') {
          this.bccSelectedFolder.push(item.value);
          mailFolderIdArray.push(this.arrListContactFolder[this.arrListContactFolder.findIndex(element => element.name == item.value)]['folder_id']);
          this.mailFolderId['bcc'] = mailFolderIdArray.toString();
        }
      }
    }
  }
  addDropdown(e, key) {
    if (key == 'to') {
      this.onAddto({ 'display': e, 'value': e.name.replace(/[ ,]+/g, "") });
    }
    if (key == 'cc') {
      this.onAddcc({ 'display': e, 'value': e.name.replace(/[ ,]+/g, "") });
    }
    if (key == 'bcc') {
      this.onAddbcc({ 'display': e, 'value': e.name.replace(/[ ,]+/g, "") });
    }

    this.istoItemAvailable = false;
    this.isbccItemAvailable = false;
    this.isccItemAvailable = false;
    this.itemsto = [];
    this.itemsbcc = [];
    this.itemscc = [];
  }
  onKey(event: KeyboardEvent, key) {
    this.getItems(event, key);
  }

  public onContextMenu($event: MouseEvent, item: any): void {
    var textAreaElem;
    textAreaElem = $event.currentTarget as HTMLTextAreaElement;
    if (textAreaElem["setRangeText"]) {
      this.target = textAreaElem
    } else {
      this.target = $event.srcElement as HTMLInputElement;
    }

    this.contextMenuService.show.next({
      // Optional - if unspecified, all context menu components will open
      contextMenu: this.contextMenu,
      event: $event,
      item: item,
    });
    if ($event.currentTarget['id'] == "bodyContainer") {
      this.contextMenuAddContainer = "Body";
    } else if ($event.currentTarget['id'] == "subjectContainer") {
      this.contextMenuAddContainer = "subject";
    }
    else if ($event.currentTarget['id'] == "toMail") {
      this.contextMenuAddContainer = "to";
    }
    else if ($event.currentTarget['id'] == "bccMail") {
      this.contextMenuAddContainer = "bcc";
    }
    else if ($event.currentTarget['id'] == "ccMail") {
      this.contextMenuAddContainer = "cc";
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  onFieldSelect(ev, fields) {
    var data = '<<' + this.selectedTemplate + '.' + fields.FieldName + '>>';
    if (this.target["setRangeText"]) {
      //if setRangeText function is supported by current browser
      this.target.setRangeText(data)
    } else {
      this.target.focus()
      document.execCommand('insertText', false /*no UI*/, data);
    }

    if (this.contextMenuAddContainer == "Body") {
      this.copyText(data);
      this.clipboardData = data;
      const toast = this.toastController.create({
        message: 'Template field copied !!',
        duration: this.configApi.toastDuration
      });
      toast.present();
    } else if (this.contextMenuAddContainer == "subject") {
      this.fieldValues.Subject = this.target.value;
    } else if (this.contextMenuAddContainer == "to") {
      this.toSelectedFolder.push(data);
      document.getElementById('toMail').querySelector('.iti-input')["value"] = "";
      this.contextValueTo.push(data);
    } else if (this.contextMenuAddContainer == "cc") {
      this.ccSelectedFolder.push(data);
      document.getElementById('ccMail').querySelector('.iti-input')['value'] = "";
      this.contextValueCc.push(data);
    } else if (this.contextMenuAddContainer == "bcc") {
      this.bccSelectedFolder.push(data);
      document.getElementById('bccMail').querySelector('.iti-input')['value'] = "";
      this.contextValueBcc.push(data);
    }
  }

  getMailList(e, type, remove = false, index = 0) {
    this.contactManager.getMailList(e, (email) => {
      if (type == "to") {
        if (!remove) {
          this.toMail = this.toMail.concat(email);
        } else {
          var mailFolderIdArr = [];
          mailFolderIdArr = this.mailFolderId[type].split(',');
          mailFolderIdArr.splice(index, 1);
          this.mailFolderId[type] = mailFolderIdArr.toString();
          for (var i = 0; i < this.toMail.length; i++) {
            for (var j = 0; j < email.length; j++) {
              if (this.toMail[i] == email[j]) {
                this.toMail.splice(i, 1);
                i--;
              }
            }
          }
        }

      } else if (type == "cc") {
        if (!remove) {
          this.ccMail = this.ccMail.concat(email);
        } else {
          var mailFolderIdArr = [];
          mailFolderIdArr = this.mailFolderId[type].split(',');
          mailFolderIdArr.splice(index, 1);
          this.mailFolderId[type] = mailFolderIdArr.toString();
          for (var i = 0; i < this.ccMail.length; i++) {
            for (var j = 0; j < email.length; j++) {
              if (this.ccMail[i] == email[j]) {
                this.ccMail.splice(i, 1);
                i--;
              }
            }
          }
        }
      } else if (type == "bcc") {
        if (!remove) {
          this.bccMail = this.bccMail.concat(email);
        } else {
          var mailFolderIdArr = [];
          mailFolderIdArr = this.mailFolderId[type].split(',');
          mailFolderIdArr.splice(index, 1);
          this.mailFolderId[type] = mailFolderIdArr.toString();
          for (var i = 0; i < this.bccMail.length; i++) {
            for (var j = 0; j < email.length; j++) {
              if (this.bccMail[i] == email[j]) {
                this.bccMail.splice(i, 1);
                i--;
              }
            }
          }
        }
      }
      if (!remove) {
        if (!this.mailFolderId[type]) {
          this.mailFolderId[type] = e.folder_id;
        } else {
          this.mailFolderId[type] = this.mailFolderId[type] + ',' + e.folder_id;
        }
      }
    });
  }

  onInputFocused(e,) {
    var key = e.key;
    this.initializeItems();
    if (key == 'to') {
      this.istoItemAvailable = true;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = false;
    }
    if (key == 'bcc') {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = true;
      this.isccItemAvailable = false;
    }
    if (key == 'cc') {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = true;
    }

  }

  onInputBlur(e, key) {
    if (key == 'to') {

    }
    if (key == 'bcc') {

    }
    if (key == 'cc') {

    }
  }

  onItemAddedTo(e) {
    this.currentSelectedTo = e.display;
    let mail = [e];
    mail.push({ mail: 'to' })
    this.onItemAdded(mail);
  }

  onItemAddedCc(e) {
    this.currentSelectedCc = e.display;
    let mail = [e];
    mail.push({ mail: 'Cc' });
    this.onItemAdded(mail);
  }
  onItemAddedBcc(e) {
    this.currentSelectedBcc = e.display;
    let mail = [e];
    mail.push({ mail: 'Bcc' });
    this.onItemAdded(mail);
  }

  onItemAdded(e) {
    this.addedFile = e[0].value;
    for (let i = 0; i < this.folder[0].folders.length; i++) {
      if (this.folder[0].folders[i].name == this.addedFile) {
        this.tempData = this.folder[0].folders[i];
      }
    }
    this.onGetResults(e);
  }

  getFromId(event) {
    this.fieldValues['From'] = event.event;
  }

  onGetResults(e) {
    this.mailData = e[1].mail;
    let data = Object.assign({}, this.tempData)
    this.driveService.pullSyncData(0, null, data, this.storeWrap.typeOfApi.summary, this.storeWrap.typeOfData.typeFile, this.loadData)
  }


  loadData = ((data) => {
    this.fieldData = data;
    if (this.mailData == "to") {
      let mail = [];
      for (let j = 0; j < this.fieldData[0].length; j++) {
        mail.push(this.fieldData[0][j].Email);
      } this.mailIdTo[this.currentSelectedTo] = mail;
    } else if (this.mailData == "Cc") {
      let mail = [];
      for (let j = 0; j < this.fieldData[0].length; j++) {
        mail.push(this.fieldData[0][j].Email);
      } this.mailIdCc[this.currentSelectedCc] = mail;
    } else if (this.mailData == "Bcc") {
      let mail = [];
      for (let j = 0; j < this.fieldData[0].length; j++) {
        mail.push(this.fieldData[0][j].Email);
      } this.mailIdBcc[this.currentSelectedBcc] = mail;
    }
  });



  //Send Mail Data
  sendMailData() {
    this.fieldValues["To"] = this.toMail.toString();
    this.fieldValues["Cc"] = this.ccMail.toString();
    this.fieldValues["Bcc"] = this.bccMail.toString();

    if (this.toMail.length > 0 && this.contextValueTo.length > 0) {
      this.fieldValues["To"] += ',' + this.contextValueTo.toString();
    } else if (this.toMail.length == 0 && this.contextValueTo.length > 0) {
      this.fieldValues["To"] = this.contextValueTo.toString();
    }

    if (this.ccMail.length > 0 && this.contextValueCc.length > 0) {
      this.fieldValues["Cc"] += ',' + this.contextValueCc.toString();
    } else if (this.ccMail.length == 0 && this.contextValueCc.length > 0) {
      this.fieldValues["Cc"] = this.contextValueCc.toString();
    }

    if (this.bccMail.length > 0 && this.contextValueBcc.length > 0) {
      this.fieldValues["Bcc"] += ',' + this.contextValueBcc.toString();
    } else if (this.bccMail.length == 0 && this.contextValueBcc.length > 0) {
      this.fieldValues["Bcc"] = this.contextValueBcc.toString();
    }
    let messageBody: any = '';
    if (this.addLink == true) {
      messageBody = this.fieldValues["Body"];
    } else {
      messageBody = this.fieldValues["Body"];
    }

    let attachment_template: any = {};
    if (this.fieldValues.attachment_template) {
      attachment_template = this.fieldValues.attachment_template;
      if (this.addLink == true) {
        attachment_template = Object.assign({}, attachment_template, { 'attachmentLink': true, "host": window.location.origin + window.location.pathname + window.location.search, "enterEmail": this.enteredTagEmail });
      } else {
        if (attachment_template.hasOwnProperty('attachmentLink')) {
          delete attachment_template['attachmentLink'];
        }
      }
    } else {
      if (this.addLink == true) {
        attachment_template = Object.assign({}, attachment_template, { 'attachmentLink': true, "host": window.location.origin + window.location.pathname + window.location.search, "enterEmail": this.enteredTagEmail });
      }
    }
    this.fieldValues.attachment_template = attachment_template;
    this.sentMailParam(messageBody);
  }

  sentMailParam(messageBody) {
    let mailBody = '';
    if ((!messageBody.includes('href=')) || messageBody.includes('href=""') || messageBody.includes("href=''")) {
      mailBody = this.convertHtml(messageBody, this.link, this.mailTemplate);
    }else{
      mailBody = messageBody
    }
    this.fieldValues["mailFolderId"] = JSON.stringify(this.mailFolderId);
    if (this.toSelectedFolder.length == 0) {
      this.fieldValues.mailFolderId = "";
      this.fieldValues.To = "";
    }
    this.fieldValues.attachment_template["accessType"] = this.accessType;
    this.fieldValues.attachment_template['ShareType'] = this.shareDataType ? 'Folder' : '';
    this.objData = Object.assign({}, this.configApi.driveApi.PushMailCampaign.params, this.fieldValues, { "Body": mailBody, "client": this.configureService.getStudio() });
    this.closeScheduler();
  }

  //Close/ Cancel Popup
  closeScheduler() {
    this.viewCtrlScheduler.dismiss(this.objData);
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }

  @ViewChild('userinputTo', { 'static': false }) userinputTo: ElementRef;
  @ViewChild('userinputCc', { 'static': false }) userinputCc: ElementRef;
  @ViewChild('userinputBcc', { 'static': false }) userinputBcc: ElementRef;
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    // if (targetElement.tagName == "SPAN") {
    //   if (targetElement.className == "modal-close-icon") {
    //     this.closeScheduler();
    //   }
    // }
    const clickedElementTo = this.userinputTo.nativeElement.contains(targetElement);
    const clickedElementCc = this.userinputTo.nativeElement.contains(targetElement);
    const clickedElementBcc = this.userinputTo.nativeElement.contains(targetElement);
    if (!clickedElementTo || !clickedElementCc || !clickedElementBcc) {
      this.istoItemAvailable = false;
      this.isbccItemAvailable = false;
      this.isccItemAvailable = false;
    } else {
      if (clickedElementTo) {
        this.istoItemAvailable = true;
        this.isbccItemAvailable = false;
        this.isccItemAvailable = false;
      } else if (clickedElementCc) {
        this.istoItemAvailable = false;
        this.isbccItemAvailable = false;
        this.isccItemAvailable = true;
      } else if (clickedElementBcc) {
        this.istoItemAvailable = false;
        this.isbccItemAvailable = false;
        this.isccItemAvailable = true;
      }
    }
  }

  convertHtml(text, link, mailTemplate) {
    let bodyHtml: any = '';
    if (mailTemplate == 'Default') {
      bodyHtml += '<div><table border="0" cellpadding="0" cellspacing="0" style="width: 100%;">' +
        '<thead border="0" cellpadding="0" cellspacing="0" width="78%"><tr><td>';
      if (text) {
        bodyHtml += '<div id="message_container" style="margin: 12px;">';
        var strArr = this.fieldValues.Body.split(/\r\n|\r|\n/gi);
        for (var i = 0; i < strArr.length; i++) {
          if (strArr[i] != "" && strArr[i + 1] == "") {
            bodyHtml += "<p>" + strArr[i] + "</p>";
          } else if (strArr[i] == "" && strArr[i + 1] == "") {
            bodyHtml += "<p>&nbsp;</p>";
          } else if (strArr[i] != "") {
            bodyHtml += "<p>" + strArr[i] + "</p>";
          }
        }
        if (strArr[strArr.length - 1] == "") {
          strArr[strArr.length - 1] = '<p class="endDiv" style="margin:0;line-height:0;padding:0">&nbsp;</p></div>';
          bodyHtml += strArr[strArr.length - 1];
        } else {
          bodyHtml += '<p class="endDiv" style="margin:0;line-height:0;padding:0">&nbsp;</p></div>';
        }
      }
      if (this.addLink == true) {
        bodyHtml += '</td></tr></thead><tbody id="folderLink_Html" style="padding: 12px;margin: 1px; background-color: #e6e6e694;" border="0" cellpadding="0" cellspacing="0">' +
          '<tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0">' +
          '<div style="margin: 12px;display: flex;"><div style="margin-left: 20px;"><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/Google_Docs_logo.svg/740px-Google_Docs_logo.svg.png" style="width: 46px;">' +
          '</div><div style="margin-top: 25px;margin-left: 16px;"><span style="font-weight:bold" id="folder_Name_container">' + this.TagName + '</span></div></div>' +
          '</td></tr><tr border="0" cellpadding="0" cellspacing="0"><td border="0" cellpadding="0" cellspacing="0"><div style="margin: 12px;" id="folder_link_container">' +
          "<a class = 'attachmentLink' href='" + this.link + "' style='color: #fff;background-color: #467fff;padding:6px 21px;border: 1px solid;border-radius: 3px;font-size: 16px;margin-left: 8px;cursor: pointer;text-decoration:none'>open</a>" +
          '</div></td></tr></tbody><tfoot style="margin:1px;background-color: #cccccc;"><tr><td></td>' +
          '</tr></tfoot></table></div><br>';
      }
      return bodyHtml;
    }
  }

  /* * * * * *
   * ck Editor Events
   * * * * * */
  onCKEditorChange($event: any): void {
    this.fieldValues.Body = $event;
  }

  onPaste($event: any): void {
  }

  onReady($event: any): void {
    var _this = this;
    $event.editor.on('contentDom', function () {
      var editable = $event.editor.editable();
      editable.attachListener(editable, 'dblclick', (event) => {
        jQuery("#bodyContainer").trigger("click");
        jQuery(".cdk-overlay-pane").css({ "top": (event.data["$"].screenY - 70), "left": (event.data["$"].screenX + 15) });
      })
      editable.attachListener(editable, 'contextmenu', (event) => {
        jQuery("#bodyContainer").trigger("click");
        jQuery(".cdk-overlay-pane").css({ "top": (event.data["$"].screenY - 70), "left": (event.data["$"].screenX + 15) });
      });

    });
  }

  onFocus($event: any): void {
  }

  copyText(val: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  getShareDataType(e) {
    if (e.target.checked == true) {
      this.shareDataType = true;
    }
  }

  getAcessType(e) {
    this.accessType = e.event;
  }


  onKeyDownEvent(e, key) {
    console.log(e.target.value)
    if (key == 'to') {
      this.enteredTagEmail.push(e.target.value)
      this.toMail.push(e.target.value)
    } else if (key == 'bcc') {

    } else if (key == 'cc') {

    }

  }
}


// WEBPACK FOOTER //
// ./src/components/form/mail-campaign/mail-campaign.ts